import { Reveal } from "./shared";

const STATS = [
  { value: "100–300 g", label: "dávka pražení" },
  { value: "~15 min", label: "od zrnka k šálku" },
  { value: "~5 min", label: "předehřátí" },
  { value: "14 kg", label: "hmotnost" },
  { value: "1250 W", label: "infra ohřev" },
  { value: "Wi-Fi", label: "aplikace + Artisan" },
];

export default function StatsStrip() {
  return (
    <section className="border-y border-stone-200 bg-[#FAF7F2]" data-testid="stats-strip">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px overflow-hidden px-6 py-14 sm:grid-cols-3 lg:grid-cols-6">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.05} y={20}>
            <div className="text-center" data-testid={`stat-${i}`}>
              <p className="font-display text-2xl font-black text-gold sm:text-3xl">{s.value}</p>
              <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.18em] text-stone-500">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
